document.addEventListener('DOMContentLoaded', function(){
  const collectionSwiper = new Swiper('.collection-swiper', {
      wrapperClass: 'collection-swiper-wrapper',
      slideClass: 'collection-swiper-slide',
      slidesPerView: 1,
      spaceBetween: 45,
      breakpoints: {
          767: {
              slidesPerView: 3,
              spaceBetween: 45,
          },
          1024: {
              slidesPerView: 4,
              spaceBetween: 45,
          }
      },
    navigation: {
      nextEl: '.swiper-collection-button-next',
      prevEl: '.swiper-collection-button-prev',
    }
  	
  })
})
